import {NAV, VIEWS} from "./consts";
import {scaleQuantize, scaleThreshold} from "d3-scale";
import {MATRIX_COLORS,
  EMPLOYMENT_RATE_COLORS_ARRAY,
  OCCUPATIONAL_ABSOLUTE_COLORS_ARRAY,
  JOB_GROWTH_COLORS_ARRAY,
  OCCUPATIONAL_RELATIVE_COLORS_ARRAY,

  EMPLOYMENT_RATE_COLORS_SHORT_ARRAY,
  OCCUPATIONAL_ABSOLUTE_COLORS_SHORT_ARRAY,
  JOB_GROWTH_COLORS_SHORT_ARRAY,
  OCCUPATIONAL_RELATIVE_COLORS_SHORT_ARRAY,

  OCCUPATIONAL_CHANGE_COLORS_ARRAY,
  OCCUPATIONAL_CHANGE_COLORS_SHORT_ARRAY,

  TERTIARY_EDUCATION_ARRAY

} from "./colors"

/*
export function pathToViewSection(path){
  const parts = path.split('/');
  return {
    type: parts[1],
    view: parts[2] ? parts[2] : parts[1],
    section: parts[4] ? parts[4] : false
  }
};*/

export function getViewBySlug(slug) {
  return NAV.find((item) => item.slug === slug)
};

export function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function normalizeString(str) {
  return str.normalize("NFD").toLowerCase().replace(/[\u0300-\u036f]/g, "");
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function removeDecimalsIfNotNeeded(x) {
  x = parseFloat(x);
  return x % 1 === 0 ? x : x.toFixed(2);
}

export function removeId(field){
  if(!field) return "";

}

export function getMapLegendLabels(view, field, selected){
  const resp = {
    title: "",
    subtitle: ""
  };

  switch (view) {
    case "regional-cluster":
      resp.title = "Labor Market Clusters";
      break;
    case "employment":
      resp.title = "Labor Market Development";
      break;
    case "occupational":
      resp.title = selected.name;
      field = field.split('_');
      field.shift();
      field = field.join('_');
      break;

    default:
      break;
  }
  switch (field) {
    case "net_job_growth_2011_18_in_share":
      resp.subtitle = "Net job growth 2011-18, in %"
      break;
    case "net_job_growth_2018_30_in_share":
      resp.subtitle = "Net job growth 2018-30, in %"
      break;
    case "employment_rate_2018":
      resp.subtitle = "Employment rate 2018, in %"
      break;
    case "employment_rate_2030_in_share":
      resp.subtitle = "Employment rate 2030, in %"
      break;

    case "employment_absolute_2018_thousands":
      resp.subtitle = "employees 2018 in thousands";
      break;
    case "employment_absolute_2030_thousands":
      resp.subtitle = "employees 2030 in thousands";
      break;
    case "employment_share_of_region_2018_percent":
      resp.subtitle = "2018 in %";
      break;
    case "employment_share_of_region_2030_percent":
      resp.subtitle = "2030 in %";
      break;
    case "jobs_change_18_30_percent":
      resp.subtitle = "2018-30 job change %";
      break;

    default:
      break;
  }
  return resp;
}

export function buildSQLArrayString(fields) {
  return `{${fields.map(f=>`${f}:${f}`).join(',')}}`;
}

export function buildSQLFirstSelectString(fields) {
  return ` ${fields.map(f => `FIRST(${f}) as ${f}`).join(',')} `;
}

export function toMillions(number) {
  return Math.round(number/1000000);
}

export function toPercentage(number, decimal) {
  number = number * 100;
  return decimal === 0 ? Math.round(number):number.toFixed(decimal);
}

export function createMatrixScale(min, max) {
  return scaleQuantize()
    .domain([min, max])
    .range(MATRIX_COLORS);
}

export function createTextColorScale(min, max) {
  return scaleQuantize()
    .domain([min, max])
    .range(['#000','#fff']);
}

export function getMapColorScale(view, field) {
  let colorPalette;
  if (view === VIEWS.EMPLOYMENT) {
    colorPalette = field.indexOf('employment_rate') > -1 ? EMPLOYMENT_RATE_COLORS_ARRAY : JOB_GROWTH_COLORS_ARRAY;
  }
  if (view === VIEWS.OCCUPATIONAL) {
    colorPalette = field.indexOf('jobs_change_18_30_percent') > -1 ? OCCUPATIONAL_CHANGE_COLORS_ARRAY : field.indexOf('absolute') > -1 ? OCCUPATIONAL_ABSOLUTE_COLORS_ARRAY : OCCUPATIONAL_RELATIVE_COLORS_ARRAY;
  }
  return colorPalette;
}

export function getLegendColorScale(view, field, defaultScale) {
  let colorPalette = defaultScale;
  if (view === VIEWS.EMPLOYMENT) {
    colorPalette = field.indexOf('employment_rate') > -1 ? EMPLOYMENT_RATE_COLORS_SHORT_ARRAY : JOB_GROWTH_COLORS_SHORT_ARRAY;
  }
  if (view === VIEWS.OCCUPATIONAL) {
    colorPalette = field.indexOf('jobs_change_18_30_percent') > -1 ? OCCUPATIONAL_CHANGE_COLORS_SHORT_ARRAY : field.indexOf('absolute') > -1 ? OCCUPATIONAL_ABSOLUTE_COLORS_SHORT_ARRAY : OCCUPATIONAL_RELATIVE_COLORS_SHORT_ARRAY;
  }
  return colorPalette;
}

export function createTertiaryEducationScale() {
  return scaleThreshold()
    .domain([0.3,0.6,0.9])
    .range([...TERTIARY_EDUCATION_ARRAY].reverse().map(d=>d[1]));
}

export function cloneAndRenameObj(obj, renameFieldList) {
  const resp = {};
  Object.keys(renameFieldList).forEach((field) => {
    resp[renameFieldList[field]] = obj[field];
  })
  return resp;
}

export function calculateLabelBounds(d, i, s) {
  return {
    width: s.width,
    height: s.height,
    x: this._x1 !== null ? this._getX(d, i) : -s.width / 2,
    y: this._x1 === null ? this._getY(d, i) : -s.height / 2
  }
};

export function calculateSide(n, gap) {
  n = Math.abs(n);
  if (n === 0) return 0;
  return n + gap;
}

export function calculateDomain(min, max, isVertical) {
  //console.log(min, max);
  const ratio = isVertical?0.5:0.1;
  const gapMin = Math.abs(min) * ratio;
  const gapMax = Math.abs(max) * ratio;
  //console.log(gapMin, gapMax);
  let biggerGap = gapMax > gapMin ? gapMax : gapMin;
  //biggerGap = biggerGap < 0.01 ? biggerGap*2:biggerGap;
  let axisMin = calculateSide(min, biggerGap);
  let axisMax = calculateSide(max, biggerGap);
  //console.log(axisMin, axisMax);
  return [min < 0 ? -1*axisMin : axisMin, axisMax];
}
